"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
var form_validation_definition_1 = require("./form-validation-definition");
var array_extensions_1 = require("../utilities/array-extensions");
var form_constants_1 = require("./form-constants");
var form_rules_1 = require("./form-rules");
var moment = require("moment");
exports.FormRecord = immutable_1.Record({
    id: '',
    name: '',
    heading: '',
    elements: immutable_1.List([]),
    rules: immutable_1.List([]),
    maxTotalAttachmentSize: null,
    includeRecaptcha: false,
});
/** Immutable SSG Form */
var Form = /** @class */ (function (_super) {
    __extends(Form, _super);
    function Form(props) {
        return _super.call(this, props) || this;
    }
    return Form;
}(exports.FormRecord));
exports.Form = Form;
;
exports.FormStateRecord = immutable_1.Record({
    allPrograms: immutable_1.List([]),
    form: new Form({}),
    initialSelectedPrograms: immutable_1.List([]),
    initialValues: immutable_1.Map({}),
    recaptchaValue: '',
    selectedPrograms: undefined,
    validationResult: new form_validation_definition_1.ValidationResult({}),
    value: immutable_1.Map({}),
    country: form_constants_1.CountryEnum.UnitedStates,
});
/** The Immutable SSG Form State */
var FormState = /** @class */ (function (_super) {
    __extends(FormState, _super);
    function FormState(props) {
        return _super.call(this, props) || this;
    }
    return FormState;
}(exports.FormStateRecord));
exports.FormState = FormState;
/**
 * Searches through all the elements in the form state to find one with a matching id.
 * This will short circuit as soon as the element is found.
 * @param state the form state
 * @param elementId the identifier of the element
 * @returns the immutable form element with an id that equals elementId
 */
function getElementById(state, elementId) {
    if (!elementId) {
        return undefined;
    }
    // Defensive check to prevent crashes when state.form or state.form.elements is undefined
    if (!state || !state.form || !state.form.elements) {
        return undefined;
    }
    // Handle both Immutable List and plain arrays for elements
    var elementsArray = array_extensions_1.normalizeToArray(state.form.elements);
    var element = getElementByIdRecursive(elementsArray, elementId);
    return element;
}
exports.getElementById = getElementById;
/**
 * Recursively searches through a list of elements for an element with a particular id. This is a breadth first search,
 * so it starts with the top level elements first and then, if the element has not been found, it will search the first level of subElements.
 * @param elements the list of elements to search through
 * @param elementId the id of the element we are searching for
 */
function getElementByIdRecursive(elements, elementId) {
    var subElements = [];
    var foundElement = undefined;
    for (var i = 0; i < elements.length; i++) {
        var element = elements[i];
        if (!element) {
            break;
        }
        else if (element.id === elementId) {
            foundElement = element;
            break;
        }
        else if (element.type === form_constants_1.elementTypes.group) {
            subElements.push.apply(subElements, element.subElements);
        }
    }
    if (!foundElement && subElements.length > 0) {
        foundElement = getElementByIdRecursive(subElements, elementId);
    }
    return foundElement;
}
/**
 * returns the current value of a specific form element in the FormState, merging the value and defaultValues in the state
 * @param {object} state the current FormState
 * @param {string} elementId id of the form element
 */
function getValue(state, elementId, country) {
    // Handle null/undefined state early to prevent crashes
    if (!state) {
        return undefined;
    }
    // Try to get element using standard approach
    // This will return undefined if state.form doesn't exist (login forms)
    var element = getElementById(state, elementId);
    // If we can't find the element (either no state.form or element not in form),
    // fall back to direct value access for login forms
    if (!element) {
        // For login forms, try to get value directly from state if it's not a proper FormState
        if (typeof state === 'object' && elementId) {
            var directValue = state[elementId] || (state.value && state.value[elementId]);
            return directValue;
        }
        return undefined;
    }
    // From here on, we have a valid element, so proceed with normal flow
    // including date formatting for regular forms
    var value = state.value, initialValues = state.initialValues;
    var elementValue = value && value.get(elementId);
    var elementDefaultValue = initialValues && initialValues.get(elementId);
    if (element.type === form_constants_1.elementTypes.group) {
        if (!element.dataFormat)
            return undefined;
        switch (element.dataFormat.type) {
            case form_constants_1.dataFormatType.MULTIPLE_CHOICE_OTHER:
                // Check if we have the new IMCOtherValue structure in current state
                if (elementValue && typeof elementValue === 'object' && 'mcValue' in elementValue) {
                    return elementValue;
                }
                // Check if we have the new IMCOtherValue structure in default values
                if (elementDefaultValue && typeof elementDefaultValue === 'object' && 'mcValue' in elementDefaultValue) {
                    return elementDefaultValue;
                }
                // Fallback to old logic for backward compatibility
                var mcValue = getValue(state, element.dataFormat.mcElementId);
                var otherValue = getValue(state, element.dataFormat.otherTextElementId);
                return { mcValue: mcValue, otherValue: otherValue };
            case form_constants_1.dataFormatType.ZIP_EXTENSION: {
                var zipValue = getValue(state, element.dataFormat.zipElementId);
                var extensionValue = getValue(state, element.dataFormat.extensionElementId);
                var groupValue = zipValue ? zipValue : '';
                if (zipValue && extensionValue)
                    groupValue += "-" + extensionValue;
                return groupValue;
            }
            case form_constants_1.dataFormatType.NONE:
            default:
                return undefined;
        }
    }
    else if (element.type === form_constants_1.elementTypes.date) {
        // allows for correct date formatting when viewing or editing existing records
        // Prefer elementValue, but if it's falsy (null, empty string, etc), fall back to elementDefaultValue
        var dateToFormat = elementValue || elementDefaultValue;
        if (!dateToFormat) {
            return undefined;
        }
        // Format the date based on country
        // Important: specify the input format when parsing to avoid misinterpretation
        // e.g., '09/01/2026' in UK format (9th Jan) should not be parsed as US format (Sep 1st)
        var dateFormattedValue = void 0;
        switch (country) {
            case form_constants_1.CountryEnum.UnitedKingdom:
                // Parse UK format input (DD/MM/YYYY) and format as UK output
                dateFormattedValue = moment(dateToFormat, 'DD/MM/YYYY', true).format('DD/MM/YYYY');
                break;
            case form_constants_1.CountryEnum.Canada:
                // Parse Canada format input (YYYY-MM-DD) and format as Canada output
                dateFormattedValue = moment(dateToFormat, 'YYYY-MM-DD', true).format('YYYY-MM-DD');
                break;
            case form_constants_1.CountryEnum.UnitedStates:
            default:
                dateFormattedValue = dateToFormat;
                break;
        }
        return dateFormattedValue;
    }
    else {
        return elementValue || elementDefaultValue || undefined;
    }
}
exports.getValue = getValue;
/** gets the currently selected programs, merges list of defaultSelectedPrograms with selectedPrograms */
function getSelectedPrograms(_a) {
    var selectedPrograms = _a.selectedPrograms, initialSelectedPrograms = _a.initialSelectedPrograms;
    return selectedPrograms !== undefined ? selectedPrograms : initialSelectedPrograms ? initialSelectedPrograms : immutable_1.List([]);
}
exports.getSelectedPrograms = getSelectedPrograms;
/**
 * Returns whether the specified element is capable of storing user input
 * @param type the type of element in question
 */
function elementStoresData(type) {
    switch (type) {
        case form_constants_1.elementTypes.emailNotification:
        case form_constants_1.elementTypes.heading:
        case form_constants_1.elementTypes.help:
        case form_constants_1.elementTypes.html:
        case form_constants_1.elementTypes.ignore:
        case form_constants_1.elementTypes.page:
        case form_constants_1.elementTypes.undefined:
        case form_constants_1.elementTypes.unsupported:
            return false;
        default:
            return true;
    }
}
exports.elementStoresData = elementStoresData;
/**
 * Determines if a given value should be considered empty based on the form element definition
 * @param element the definition of the element we are evaluating
 * @param value the current value of the element
 * @param state the form state, to get values for subElements of a group
 * @returns true if the given value should be considered empty
 */
function hasEmptyValue(element, value, state) {
    if (state === void 0) { state = new FormState({}); }
    switch (element.type) {
        case form_constants_1.elementTypes.radio:
        case form_constants_1.elementTypes.select:
        case form_constants_1.elementTypes.checkbox:
        case form_constants_1.elementTypes.likert:
            // NOTE: likert was previously grouped here, likert cannot have "allow other" as an option
            // Check for individual element "allow other" functionality
            if (element.otherOptionValue && element.otherTextElementId) {
                var mcElement_1 = element; // Cast to access allow other properties
                // Basic empty check first
                if (!value || (immutable_1.List.isList(value) && value.size === 0) || isListWithOnlyEmptyValues(value)) {
                    return true;
                }
                // If multiple choice has a value, check if "other" option was selected
                if (immutable_1.List.isList(value) && value.size > 0) {
                    var selectedOptions = mcElement_1.options.filter(function (opt) { return value.includes(opt.value); });
                    var hasOtherSelected = selectedOptions.some(function (option) { return option.value === mcElement_1.otherOptionValue; });
                    if (hasOtherSelected) {
                        // "Other" option selected - element is only valid if text field has content
                        var otherValue = getValue(state, mcElement_1.otherTextElementId);
                        return !otherValue || otherValue === '';
                    }
                    // Regular option selected (not "other") - element is valid
                    return false;
                }
                // Fallback to default logic
                return !value || (immutable_1.List.isList(value) && value.size === 0) || isListWithOnlyEmptyValues(value);
            }
            // Default logic for multiple choice elements without "allow other"
            return !value || (immutable_1.List.isList(value) && value.size === 0) || isListWithOnlyEmptyValues(value);
        case form_constants_1.elementTypes.number:
            return value === undefined || value === null || value === "";
        case form_constants_1.elementTypes.group:
            // Special handling for MULTIPLE_CHOICE_OTHER groups
            // These groups contain a multiple choice element + text element for "other" input
            if (element.dataFormat && element.dataFormat.type === form_constants_1.dataFormatType.MULTIPLE_CHOICE_OTHER) {
                var dataFormat_1 = element.dataFormat;
                var mcValue = void 0;
                var otherValue = void 0;
                // The 'value' parameter is the element's value itself, which could be:
                // 1. An IMCOtherValue object: { mcValue: [...], otherValue: '...' }
                // 2. undefined/null if no value is set yet
                // We should NOT try to extract it from the value parameter with .get()
                // Check if the IMCOtherValue structure exists by checking for the property, not just if it's defined
                if (value && typeof value === 'object' && 'mcValue' in value) {
                    // Value is already the IMCOtherValue structure (even if mcValue/otherValue are undefined)
                    mcValue = value.mcValue;
                    otherValue = value.otherValue;
                }
                else {
                    // Fall back to reading from sub-element IDs in state (for backward compatibility)
                    mcValue = getValue(state, dataFormat_1.mcElementId);
                    otherValue = getValue(state, dataFormat_1.otherTextElementId);
                }
                // Get the multiple choice element to check if it's empty
                var mcElement = getElementById(state, dataFormat_1.mcElementId);
                if (!mcElement) {
                    return true; // If element doesn't exist, consider group empty
                }
                // Check if multiple choice element is empty (including empty strings in Lists)
                var mcIsEmpty = hasEmptyValue(mcElement, mcValue, state);
                // Group is empty only if both multiple choice and other text are empty
                if (mcIsEmpty && (!otherValue || otherValue === '')) {
                    return true;
                }
                // If multiple choice has a selection, check if "other" option was selected
                if (!mcIsEmpty && mcElement.options) {
                    var mcValueArray_1 = array_extensions_1.normalizeToArray(mcValue);
                    var selectedOptions = mcElement.options.filter(function (opt) { return mcValueArray_1.includes(opt.value); });
                    var hasOtherSelected = selectedOptions.find(function (option) { return option.value === dataFormat_1.otherOptionValue; }) !== undefined;
                    if (hasOtherSelected) {
                        // "Other" option selected - group is only valid if text field has content
                        return !otherValue || otherValue === '';
                    }
                }
                // Either mc is empty (but otherValue has content), or mc has a non-other selection
                return false;
            }
            // Default group logic for other data formats
            var emptyGroup = true;
            element.subElements.forEach(function (subElement) {
                var subElementValue = getValue(state, subElement.id);
                if (!subElement.hidden && !subElement.disabled)
                    emptyGroup = emptyGroup && hasEmptyValue(subElement, subElementValue, state);
            });
            return emptyGroup;
        case form_constants_1.elementTypes.electronicSignature:
            if (value === undefined)
                return true;
            if (typeof (value) !== 'object')
                return false;
            if (element.mode === form_constants_1.electronicSignatureModes.ETO) {
                var coord = value.get('etoCoords');
                return (!coord || coord.size === 0);
            }
            else if (element.mode === form_constants_1.electronicSignatureModes.APRICOT) {
                var coord = value.get('imageUrl');
                return (!coord || coord.length === 0);
            }
            else {
                return true;
            }
        case form_constants_1.elementTypes.time:
            if (!!value && typeof (value) !== 'object') {
                return false;
            }
            return !value || (!value.hour && !value.minute);
        default: return !elementStoresData(element.type) || !value;
    }
}
exports.hasEmptyValue = hasEmptyValue;
/**
 * Helper function to check if a List contains only empty values (empty strings, null, undefined)
 * @param value the value to check
 * @returns true if the value is a List containing only empty values
 */
function isListWithOnlyEmptyValues(value) {
    if (!immutable_1.List.isList(value) || value.size === 0) {
        return false;
    }
    return value.every(function (val) { return val === "" || val === null || val === undefined; });
}
/**
 * This function returns an altered version of the subElement, based on its parent groupElement.
 * If the groupElement is hidden, disabled, isRequired, or readOnly then the modified subElement will also have those properties.
 * @param groupElement the group element definition
 * @param subElement the sub element within the group
 * @returns a modified version of the subElement
 */
function getModifiedSubElement(groupElement, subElement) {
    var modifiedElement = subElement;
    modifiedElement = modifiedElement.set('hidden', groupElement.hidden || subElement.hidden)
        .set('disabled', groupElement.disabled || subElement.disabled);
    if (elementStoresData(subElement.type)) {
        var inputElement = subElement;
        var requiredByGroup = groupElement.isRequired && isSubElementRequiredByGroup(groupElement, subElement);
        modifiedElement = modifiedElement.set('isRequired', requiredByGroup || inputElement.isRequired)
            .set('readOnly', groupElement.readOnly || inputElement.readOnly);
    }
    return modifiedElement;
}
exports.getModifiedSubElement = getModifiedSubElement;
/**
 * Determines if a particular subElement should required when the group is required
 * @param groupElement the group element, containing all subElements
 * @param subElement the particular subElement being evaluated
 */
function isSubElementRequiredByGroup(groupElement, subElement) {
    var requiredDefinition = groupElement.requiredDefinition;
    // defaults to ALL option
    if (!requiredDefinition) {
        return true;
    }
    switch (requiredDefinition.type) {
        case form_constants_1.requireType.SOME:
            var subElementId_1 = subElement.id;
            return requiredDefinition.requiredSubElements &&
                requiredDefinition.requiredSubElements.some(function (val) { return val === subElementId_1; });
        case form_constants_1.requireType.ANY:
            return false;
        case form_constants_1.requireType.ALL:
        default:
            return true;
    }
}
exports.isSubElementRequiredByGroup = isSubElementRequiredByGroup;
/**
 * Gets information about a particular element including the path needed to update it in the form state.
 * This unlike getAllElementInfo will short circuit when it finds the given element.
 * @param state the form state that contains the elements
 * @param elementId the id of the element that we want to find
 */
function getElementInfo(state, elementId) {
    var form = state.form;
    var elements = form.elements;
    var basePath = ['form', 'elements'];
    // Handle both Immutable List and plain arrays for elements
    var elementsArray = array_extensions_1.normalizeToArray(elements);
    return recursiveGetElementInfo(elementsArray, basePath, elementId);
}
exports.getElementInfo = getElementInfo;
/**
 * Recursive search function that returns an element and the path to get to it.
 * @param elements the list of elements to search through
 * @param path the path to get to this list of elements
 * @param elementId the id of the element we are searching for
 */
function recursiveGetElementInfo(elements, path, elementId) {
    var groupElements = [];
    var foundElement = undefined;
    for (var i = 0; i < elements.length; i++) {
        var element = elements[i];
        if (element.id === elementId) {
            var defaultPath = path.concat([i]);
            foundElement = {
                element: element,
                path: defaultPath
            };
            break;
        }
        else if (element.type === form_constants_1.elementTypes.group) {
            var groupPath = path.concat([i, 'subElementsList']);
            groupElements.push({
                element: element,
                path: groupPath
            });
        }
    }
    if (!foundElement && groupElements.length > 0) {
        for (var i = 0; i < groupElements.length; i++) {
            var groupInfo = groupElements[i];
            foundElement = recursiveGetElementInfo(groupInfo.element.subElements, groupInfo.path, elementId);
            if (foundElement) {
                break;
            }
        }
    }
    return foundElement;
}
/**
 * This will get all the elements in the formstate that have isPreviewElement set to true
 * @param state the form state that contains the elements
 */
function getAllPreviewElementInfo(state) {
    var allElements = getAllElementInfo(state);
    return allElements.filter(function (val) { return val.element.isPreviewElement; });
}
exports.getAllPreviewElementInfo = getAllPreviewElementInfo;
/**
 * This will search through all the elements in the formstate and return [[ElementInformation]] for all of them
 * @param state the form state that contains the elements
 */
function getAllElementInfo(state) {
    var form = state.form;
    var elements = form.elements;
    var basePath = ['form', 'elements'];
    return recursiveGetAllElements(elements, basePath);
}
exports.getAllElementInfo = getAllElementInfo;
/**
 * A recursive function that will go through the list of elements and return information about them.
 * If the list contains any group elements it will also process the subElements of that group.
 * @param elements list of elements to get information about
 * @param path the current path in the form state to this list of elements
 */
function recursiveGetAllElements(elements, path) {
    var allElements = [];
    elements && elements.forEach(function (element, index) {
        switch (element.type) {
            case form_constants_1.elementTypes.group: {
                var groupPath = path.concat([index, 'subElementsList']);
                allElements.push.apply(allElements, recursiveGetAllElements(element.subElementsList, groupPath));
            }
            default:
                var defaultPath = path.concat([index]);
                allElements.push({
                    element: element,
                    path: defaultPath
                });
                break;
        }
    });
    return allElements;
}
/**
 * Given an IOperationCondition, traverse the subconditions
 * to build a list of all element ids that are referenced within.
 * This will recurse as necessary.
 * @param opCond The operation condition to flatten.
 * @returns Array<string> of all the element ids utilized in the given opCond.
 */
function flattenOpConditionIds(opCond) {
    var idList = [];
    opCond.conditions.forEach(function (oneCon) {
        if (form_rules_1.isConditionOperatorType(oneCon.type)) {
            // recurse
            var opCond_1 = oneCon;
            idList = idList.concat(flattenOpConditionIds(opCond_1));
        }
        else if (form_rules_1.isConditionElementComparisonType(oneCon.type)) {
            // add the element id and the value
            var compCond_1 = oneCon;
            if (idList.findIndex(function (id) { return id === compCond_1.elementId; }) === -1) {
                idList.push(compCond_1.elementId);
            }
            if (idList.findIndex(function (id) { return id === compCond_1.value; }) === -1) {
                idList.push(compCond_1.value);
            }
        }
        else if (form_rules_1.isConditionElementStateType(oneCon.type)) {
            // just add the element id
            var stateCond_1 = oneCon;
            if (idList.findIndex(function (id) { return id === stateCond_1.elementId; }) === -1) {
                idList.push(stateCond_1.elementId);
            }
        }
        else if (form_rules_1.isConditionElementValueType(oneCon.type)) {
            // just add the element id
            var valCond_1 = oneCon;
            if (idList.findIndex(function (id) { return id === valCond_1.elementId; }) === -1) {
                idList.push(valCond_1.elementId);
            }
        }
    });
    return idList;
}
exports.flattenOpConditionIds = flattenOpConditionIds;
/**
 * Checks form rules for the associated element. If that element is affected by any rules on the form,
 * return a list of the element ids that are assessed by those rules (if the rules are supported)
 * @param baseForm The original form that contains the rules and set of elements we need to process.
 * @param elementId id of the form element to check which rules affect it
 * @returns {Array} list of element ids as strings. these are elements which are
 *  assessed in a form rule whose conditions may result in an action being taken on the target element
 */
function getAssessedElementsForTarget(baseForm, elementId) {
    var assessedElements = [];
    if (!baseForm || !elementId) {
        // no valid form or element id to check; return empty array.
        return assessedElements;
    }
    if (!baseForm.rules || baseForm.rules.size === 0) {
        // form and id are valid, but the rules do not exist, or the rule
        // list is empty. Return empty array in this case too.
        return assessedElements;
    }
    var rules = baseForm.rules;
    var addAssessedForRule;
    rules.forEach(function (rule) {
        var condition = rule.condition, conditionActions = rule.conditionActions, disabled = rule.disabled;
        if (disabled || !form_rules_1.isRuleSupported(rule)) {
            // do not stealth add in this case
            return;
        }
        addAssessedForRule = false;
        // if the passed in elementId appears anywhere in our condition actions,
        // we have work to do
        conditionActions && conditionActions.forEach(function (ca) {
            var targetElement = ca.elementId;
            if (targetElement === elementId) {
                addAssessedForRule = true;
            }
        });
        // if the conditional rule affects the element in question, add the assessed elements to the list
        if (addAssessedForRule) {
            if (form_rules_1.isConditionOperatorType(condition.type)) {
                var opCond = condition;
                assessedElements = assessedElements.concat(flattenOpConditionIds(opCond));
            }
            else {
                if (form_rules_1.isConditionElementComparisonType(condition.type)) {
                    var compCond_2 = condition;
                    if (compCond_2.elementId !== elementId && !assessedElements.find(function (ae) { return ae === compCond_2.elementId; })) {
                        assessedElements.push(compCond_2.elementId);
                    }
                    if (compCond_2.value !== elementId && !assessedElements.find(function (ae) { return ae === compCond_2.value; })) {
                        assessedElements.push(compCond_2.value);
                    }
                }
                else if (form_rules_1.isConditionElementStateType(condition.type)) {
                    var stateCond_2 = condition;
                    if (!assessedElements.find(function (ae) { return ae === stateCond_2.elementId; })) {
                        assessedElements.push(stateCond_2.elementId);
                    }
                }
                else if (form_rules_1.isConditionElementValueType(condition.type)) {
                    var valCond_2 = condition;
                    if (!assessedElements.find(function (ae) { return ae === valCond_2.elementId; })) {
                        assessedElements.push(valCond_2.elementId);
                    }
                }
            }
        }
    }); // end rules iteration
    return assessedElements;
}
exports.getAssessedElementsForTarget = getAssessedElementsForTarget;
//# sourceMappingURL=form-definition.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms-processing/dist/form-definition/form-definition.js
// module id = 1104
// module chunks = 0